import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { http } from "../../utils/httpCommon";
import { useApiUrls } from "../useApiUrl";

const unassignShipmentIdsQueryKey = (
  serviceCenterId: number,
  planDate: number
) => ["unassignedShipments", serviceCenterId, planDate];

const unassignedShipmentsResponseSchema = z.array(z.number());

export const useUnassignedShipmentIds = (
  serviceCenterId: number,
  planDate: number
) => {
  const hookUrls = useApiUrls();
  const { getUnassignedShipments } = hookUrls;
  return useQuery({
    queryKey: unassignShipmentIdsQueryKey(serviceCenterId, planDate),
    queryFn: async () => {
      const url = getUnassignedShipments(serviceCenterId, planDate);
      const { data } = await http.get(url);
      return unassignedShipmentsResponseSchema.parse(data);
    },
  });
};
